import Vue from 'vue'
import App from '@/App'
import Router from '@/router'
import Api from '@/api'
import PDFPreviewApi from '@/api/pdfPreview'
import InitiativeApi from '@/api/initiative'
import AppHelper from '@/helper'
import i18n from '@/languages'
import Store from '@/store'
import AppMixin from '@/mixins/AppMixin'
import '@/filters/index'
import '@/directives/index'
import Popover from 'vue-js-popover'
import { getEnvVar } from '@/utils/env'

Vue.use(Popover)

//import { sync } from 'vuex-router-sync'
import Popper from 'popper.js'
import Bootstrap from 'bootstrap'
import VeeValidate from '@/validator'
import scrollbar from 'jquery.scrollbar'
import scrollLock from 'jquery-scroll-lock'
import mCustomScrollbar from 'malihu-custom-scrollbar-plugin'

// TODO: add i18n
Vue.config.productionTip = false
Vue.mixin(AppMixin)
Vue.prototype.$eventBus = new Vue()

//sync(Store, Router)

window.AppHelper = AppHelper
window.Api = new Api(getEnvVar('VUE_APP_BASE_URL') + getEnvVar('VUE_APP_API_URL'))
window.PDFPreviewApi = new PDFPreviewApi(getEnvVar('VUE_APP_BASE_URL') + getEnvVar('VUE_APP_PDF_PREVIEW_API_URL'))
window.InitiativeApi = new InitiativeApi(getEnvVar('VUE_APP_BASE_URL') + getEnvVar('VUE_APP_INITIATIVE_API_URL'))

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router: Router,
    i18n: i18n,
    store: Store,
    components: { App },
    template: '<App/>'
});